var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassEmptyState",
    {
      attrs: {
        illustrationPath:
          "/ressources/logged/img/illustrations/empty-automation.svg",
        title: _vm.translations.title,
        caption: _vm.translations.caption
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "automation-listing-empty-state-no-automation__actions"
        },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.translations.actions.explore_templates,
              type: "secondary"
            },
            on: { click: _vm.redirectToAutomationTemplates }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: { label: _vm.translations.actions.create_automation },
            on: { click: _vm.handleCreateAutomation }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }